import { trackEvent } from "app/checkout-modal/trackEvent";

export const emitRedirectEvent = async (url: string) => {
  trackEvent("redirect", {
    type: "redirect",
    payload: { url },
  });
};
